/* eslint-disable */
/* this file is generated by generateIcons script */

import * as React from 'react'
import BaseIcon from '../../BaseIcon'

export default class NewIcon extends BaseIcon {
    getChildren = () => [
        <path fill={this.getColor()}
              d="M11.53,9,9,11.53V15H8V11.53L5.47,9H2V8H5.53L8,5.53V2H9V5.53L11.47,8H15V9ZM11,6V5h1V6Zm1-2h1V5H12ZM5,5H6V6H5ZM4,4H5V5H4Zm2,7v1H5V11ZM5,13H4V12H5Zm7-1H11V11h1Zm1,1H12V12h1Z"/>
    ]
    getViewBox = () => '0 0 18 18'
}
